import React from 'react';

export const Button = ({ children, variant = 'primary', href, onClick, className = '', type = "button" }) => {
  const baseStyle = "inline-flex items-center justify-center px-6 py-3.5 rounded-md font-medium transition-all duration-200 text-sm md:text-base";
  
  const variants = {
    primary: "bg-brand-accent hover:bg-brand-accentHover text-white shadow-lg shadow-brand-accent/20",
    secondary: "bg-transparent border border-brand-border text-brand-text hover:border-brand-text/50 hover:text-white"
  };

  const combinedClasses = `${baseStyle} ${variants[variant]} ${className}`;

  if (href) {
    return (
      <a href={href} className={combinedClasses} onClick={onClick}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} className={combinedClasses} onClick={onClick}>
      {children}
    </button>
  );
};